import { render, staticRenderFns } from "./DrivewealthW9.vue?vue&type=template&id=479a523d&scoped=true"
import script from "./DrivewealthW9.vue?vue&type=script&lang=ts"
export * from "./DrivewealthW9.vue?vue&type=script&lang=ts"
import style0 from "./DrivewealthW9.vue?vue&type=style&index=0&id=479a523d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a523d",
  null
  
)

export default component.exports